import { useAppDispatch, useAppState } from '@/store';
import { useEffect } from 'react';
import {
  getConversations,
  selectConversations,
  selectConversationsIsLoading,
  selectConversationsPagination,
} from '../feature';
import { GetConversationsDTO } from '../dtos';
import { TConversationFilters } from '../helpers';

export const useGetConversations = (filters: TConversationFilters, page: number) => {
  const dispatch = useAppDispatch();
  const conversations = useAppState(selectConversations);
  const isLoading = useAppState(selectConversationsIsLoading);
  const pagination = useAppState(selectConversationsPagination);

  useEffect(() => {
    dispatch(getConversations(new GetConversationsDTO({ page, ...filters })));
  }, [dispatch, filters, page]);

  return { conversations, isLoading, pagination };
};
